// extracted by mini-css-extract-plugin
module.exports = {"button_danger":"ButtonDanger_button_danger__2ZD9E","button_danger_inverse":"ButtonDanger_button_danger_inverse__Ss98H","disabled":"ButtonDanger_disabled__2iQdy"};